import clsx from "clsx";
import React from "react";

type DividerProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function Divider(props: DividerProps) {
    const { className, ...rest } = props;

    return <div className={clsx("w-full h-[1px] bg-slate-200", className)} {...rest}></div>;
}
